import React from 'react';
import { connect } from 'react-redux';
import { find, isEqual, capitalize, uniqBy } from 'lodash';
import ReactTable from 'react-table';
import Box from '../Box';
import ReactSelect from '../../common/ReactSelect';
import CSV from '../../../helpers/CSVExport';
import ConfirmClick from '../ConfirmClick';
import { transactionTypeSettings } from './TransactionTypes/Settings';
import { statsActions } from '../../../data/actions/stats';
import StackedBarChart from '../../widgets/charts/types/StackedBarChart';
import LineChart from '../../widgets/charts/types/LineChart';

var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');
var barSvg = require('!svg-inline-loader!../../../../public/img/chart-bar.svg');
var lineSvg = require('!svg-inline-loader!../../../../public/img/line.svg');
var tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');


class TransactionTypes extends React.Component {
    
    nullElement = {value: null, label: 'All'}
    
    constructor(props) {
        super(props);
        this.state = {
            mode: 'table',
            chartMode: 'income',
            physicalTypesMode: 'transactions'
        }
        this.exportToCsv = this.exportToCsv.bind(this);
        this.getTimeseries =  this.getTimeseries.bind(this);
        this.getTimeseriesData = this.getTimeseriesData.bind(this);
        this.setChartMode = this.setChartMode.bind(this);
        this.setPhysicalTypesMode = this.setPhysicalTypesMode.bind(this);
    }
    
    exportToCsv(){
        const { entity, id } = this.props,
            { transactions, transactionsLoading } = this.props.stats,
            transactionData = transactions[id] || [];
            
        const filename = CSV.CSVHeader('transaction_types', (id && id !== 'all' ? id : null), this.props.filter.global, null, this.props.parentEntityName);
        return CSV.CSVExport(transactionData, {filename}, 'transaction_types');
    }
    
    getTimeseries() {
        this.props.getTransactionsTimeseries(this.props.entity, this.props.id);
    }

    renderToolbar(data){
        let toolbar = [];
        const { mode, chartMode, physicalTypesMode } = this.state;
        const chartModes = [
            {label: 'Income', value: 'income'},
            {label: 'Quantity', value: 'quantity'},
        ];
        const currentChartMode = find(chartModes, m=>m.value == chartMode);
        
        const physicalTypesModes = [
            {label: 'Transactions', value: 'transactions'},
            {label: 'Formats', value: 'formats'}
        ]
        const currentPhysicalTypeMode = find(physicalTypesModes, m=>m.value == physicalTypesMode);
        
        toolbar.push(<div key="wrapper" className="ibox-action-holder">
        <div className="ibox-actions">
            {mode !== 'table' && <ReactSelect options={chartModes} value={currentChartMode} onChange={this.setChartMode} className="single-select" />} 
            
            {mode == 'table' && <React.Fragment>Format Classification: <ReactSelect options={physicalTypesModes} value={currentPhysicalTypeMode} onChange={this.setPhysicalTypesMode} className="single-select" /></React.Fragment>} 


            <ConfirmClick confirmAction={this.exportToCsv} title="Export CSV" confirmClass="" confirmLabel={<span key="download" className="chart-icon download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />} confirmPrompt="These reports are for analytical purposes only and should not be used to pay artist royalties"></ConfirmClick>
            <a key='table' title="Table" className={`chart-icon ${this.state.mode == 'table' ? 'active' : ''}`} 
                onClick={()=>this.setMode('table')}
                dangerouslySetInnerHTML={{__html: tableSvg}}>
            </a>
            <a key='line' title="Line Chart" className={`chart-icon ${this.state.mode == 'line' ? 'active' : ''}`} 
                onClick={()=>{this.setMode('line'); this.getTimeseries();}}
                dangerouslySetInnerHTML={{__html: lineSvg}}>
            </a>
            <a key='bar' title="Bar Chart" className={`chart-icon ${this.state.mode == 'bar' ? 'active' : ''}`} 
                onClick={()=>{this.setMode('bar'); this.getTimeseries();}}
                dangerouslySetInnerHTML={{__html: barSvg}}>
            </a>
            
        </div>

        </div>)

        return toolbar;
    }
            
    setMode(mode){
        this.setState({mode}, ()=>{
        });
    }
    
    setChartMode(mode){
        this.setState({chartMode: mode.value});
    }
    
    setPhysicalTypesMode(mode){
        this.setState({physicalTypesMode: mode.value}, ()=>{
            this.props.getTransactions(this.props.entity, this.props.id, this.state.physicalTypesMode);    
        });
    }

    componentDidMount() {
        this.props.getTransactions(this.props.entity, this.props.id, this.state.physicalTypesMode);
    }
    
    componentWillReceiveProps(nextProps){
        if(nextProps.filter && nextProps.filter.global){
            if(this.props.filter.global!==undefined && !isEqual(nextProps.filter.global, this.props.filter.global)) {
                this.props.getTransactions(this.props.entity, this.props.id, this.state.physicalTypesMode);
                if(this.state.mode == 'line' || this.state.mode == 'bar')
                    this.getTimeseries();
            }                
        }
    }
    
    getTimeseriesData(chartData){
        const { chartMode } = this.state;
        if(chartData && chartData.datasets) {
            for(let dataset of chartData.datasets)
                dataset['data'] = [...dataset[chartMode]];
        }
            
        return chartData;
    }
    
    render (){  
        const { entity, id } = this.props,
            { transactions, transactionsLoading, transactionsTimeseriesLoading } = this.props.stats,
            entityTitle = entity == 'imprints' ? 'Labels' : capitalize(entity), 
            widgetTitle = `${entityTitle == 'Mixed' ? '' : `${entityTitle} ` }Transaction Types`,
            transactionData = transactions[id] || [];
            
        
        const rowsCount = uniqBy(transactionData, 'source').length;
        
        return <Box title={widgetTitle} toolbar={this.renderToolbar()} spinnerEnabled={(transactionsLoading||transactionsTimeseriesLoading)} className="ibox-container transaction-box ">
        {rowsCount > 0 && <React.Fragment>
            {this.state.mode=='table' && <ReactTable 
                className="transaction-table"
                data={transactionData} 
                columns={transactionTypeSettings.settingsForTable()}
                defaultPageSize={rowsCount}
                sorted={[{id: 'total_income', desc: true}]}
                pivotBy={['source', 'classification']}
            	showPagination={false}        	
            />}
            {this.state.mode=='line' && <div className="chart-block">
                <LineChart data={this.getTimeseriesData(this.props.stats.transactionsTimeseries[id])} />                          
            </div>}
            {this.state.mode=='bar' && <div className="chart-block">
                <StackedBarChart data={this.getTimeseriesData(this.props.stats.transactionsTimeseries[id])} />                          
            </div>}
        </React.Fragment>}
        </Box>;
    }
}

function mapStateToProps(state) {
    return {
        stats: state.stats,
    } 
}

function mapStateToProps(state) {
    return {
        stats: state.stats,
        filter: state.filter
    } 
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        getTransactions: (entity, id, physical) => {
            dispatch(statsActions.getTransactions(entity, id, physical))
        },
        getTransactionsTimeseries: (entity, id) => {
            dispatch(statsActions.getTransactionsTimeseries(entity, id))
        } 
        
    } 
}


export default connect(mapStateToProps, mapDispatchToProps)(TransactionTypes);